import React, {useEffect, useState} from 'react';
import searchIcon from '../../../imgs/search.svg';
import searchWhite from '../../../imgs/searchWhite.svg';
import ProfileCard from './profileCard';
import ProfileSideBar from './../profileSidebar/profileSidebar';
import {GET_BOUNTIES} from './../../../graphql/query/bounties';
import {gql, useLazyQuery} from '@apollo/client';
import {removeDuplicates} from './../../../utils/helpers/reusableFuntions';
import InfiniteScroll from 'react-infinite-scroll-component';
import {Spin} from 'antd';
import lodash from 'lodash';


const Home = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [start, setStart] = useState(0);
  const [limit] = useState(10);
  const [query, setQuery] = useState('');
  const [bounties, setBounties] = useState([]);
  const [rendering, setRendering] = useState(true);
  const [hasMore] = useState(true);
  const [isNextRequest, setIsNextRequest] = useState(true);

  const [getBounties, {data: bountiesList, loading: bountiesLoading}] =
    useLazyQuery(gql(GET_BOUNTIES), {
      fetchPolicy: 'cache-and-network',
    });

  const debounce = lodash.debounce((event) => handleSearchQuery(event), 1000);

  const handleSearchQuery = (value) => {
    setStart(0);
    getBounties({variables: {query: query, start: 0, limit}});
  };

  useEffect(() => {
    if (!bounties.length && rendering) {
      setRendering(false);
      getBounties({variables: {query: query, start, limit}});
    }
  }, []);

  useEffect(() => {
    debounce(query);
  }, [query]);

  useEffect(() => {
    if (bountiesList && bountiesList.searchBounties) {
      setIsNextRequest(true);
      if (query) {
        setBounties(bountiesList.searchBounties);
      } else {
        // if (!bountiesList.searchBounties.length) setHasMore(false)
        let mergeBounties = [...bounties, ...bountiesList.searchBounties];
        const result = removeDuplicates(mergeBounties);

        setBounties(
          result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)),
        );
      }
    }
  }, [bountiesList]);

  const fetchMoreData = () => {
    if (isNextRequest) {
      setStart(start + 10);
      setIsNextRequest(false);
      getBounties({variables: {query: query, start: start + 10, limit}});
    }
  };

  return (
    <div className="home-container">
      <ProfileSideBar />
      <div className="home-content">
        <div className="home-search">
          <h2 className="heading">
            $1,000,000<span> Active bounties</span>
          </h2>
          <button
            className="search-btn"
            onClick={() => setShowSearch(!showSearch)}>
            <img src={searchIcon} alt="logo" />
          </button>
          {showSearch && (
            <div className="search-bar">
              <img src={searchWhite} alt="logo" />
              <input
                type="search"
                value={query}
                onChange={(event) => {
                  setQuery(event.target.value);
                }}
                placeholder="Search name, company"
              />
            </div>
          )}
        </div>
        <div className="home-info">
          <h2 className="small-heading">Get paid to make warm intros.</h2>
          <p>Make intro if you have the connection.</p>
        </div>
        {/* <div className="home-content-feeds"> */}
        {/* <div style={{overflow:'scroll'}}> */}
        {bounties && bounties.length ? (
          <InfiniteScroll
            dataLength={bounties.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <Spin
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'fixed',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                }}
                spinning={bountiesLoading}></Spin>
            }>
            {bounties.map((bounty, index) => {
              return (
                <div>
                  <ProfileCard key={index} bounty={bounty} />
                </div>
              );
            })}
          </InfiniteScroll>
        ) : (
          <></>
        )}
        {/* </div> */}

        {/* </div> */}
      </div>
    </div>
  );
};

export default Home;
